import api from "./api";

const billingHistoryService = {
  async getBillingHistory(clientEmail, params = {}) {
    if (!clientEmail) {
      throw new Error("Client email is required");
    }

    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.status) queryParams.append("status", params.status);
    if (params.type) queryParams.append("type", params.type);

    const queryString = queryParams.toString();
    const url = `/billing-history/${clientEmail}${
      queryString ? `?${queryString}` : ""
    }`;

    try {
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch billing history",
      };
    }
  },
};

export default billingHistoryService;
